module.exports = __webpack_public_path__ + "img/pic_1_2.c817e90e.jpg";